<template>
  <div class="standard-dialog-fullscreen"
    :style="`${full_element?`
      height: 100%;
      width: 100%;
      margin-top: 0px;
      margin-left: 0px;
      top: 0px;
      left: 0px;
      `:
      `height: ${getHeight()}px !important;
      `
      }
      ${opacity?`background-color: rgba(0,0,0, ${opacity})`:''}
      `"
    >
    <!-- margin-top: -${getHeight()/2}px !important; -->
    <transition name="dialog_slide">
      <slot name="dialog"/>
    </transition>
    <div
      :style="`${header_max_height?'height: ' + header_max_height + 'px;':''}`"
      class="standard-dialog-fullscreen-header t-shadow color-4">
      <div class="standard-dialog-fullscreen-header-workpackages">
        <slot name="header-workpackages"/>
      </div>
      <!-- :style="`${header_max_height?'max-height: ' + header_max_height + 'px;':''}`" -->
      <div class="standard-dialog-fullscreen-header-text">
        <slot name="header-text"/>
      </div>
      <div class="standard-dialog-fullscreen-header-close">
        <slot name="header-close"/>
      </div>
    </div>
    <div class="nav-left self-centered">
      <slot name="nav-left"/>
    </div>
    <div class="nav-right self-centered">
      <slot name="nav-right"/>
    </div>
<!-- height: calc(100% - 48px); -->
<!-- :style="`${header_max_height?'height: calc(100% - ' + header_max_height + 'px);':''}`" -->
    <div
      :style="`${header_max_height?`height: calc(100% - ${header_max_height}px);`:''}
      ${overflow_auto?'overflow: auto;':''}
      `"
      class="standard-dialog-fullscreen-content">
      <slot name="content"/>
    </div>
  </div>
</template>
<script>
export default {
  props: ['header_max_height', 'full_element', 'overflow_auto', 'opacity'],
  methods: {
    getHeight() {
      return window.innerHeight
    }
  }
}
</script>
<style>
  .standard-dialog-fullscreen {
    /* height: 100vh; */
    /* margin-top: -50vh; */

    /* position: fixed; */
    width: 100vw;
    /* margin-left: -50vw;
    top: 50%;
    left: 50%; */
    display: flex;
    flex-direction: column;
    background-color: rgba(0,0,0, 0.8);
    z-index: 1;
    position: fixed;
    left: 0px;
    top: 0px;
  }
  .standard-dialog-fullscreen-header {
    display: flex;
    height: 48px;
    width: 100%;
    align-items: center;
  }
  .standard-dialog-fullscreen-header-close {
    position: absolute;
    display: flex;
    right: 10px;
  }
  .standard-dialog-fullscreen-header-workpackages {
    display: flex;
  }
  .standard-dialog-fullscreen-header-text {
    position: absolute;
    max-height: 40px;
    height: 100%;
    left: 50%;
    display: flex;
    flex-direction: column;
    align-items: center;
    color: white;
    transform: translateX(-50%);
    overflow: auto;
    line-height: 20px;
  }
  .nav-left {
    position: absolute;
    left: 22px;
    top: 50%;
    z-index: 10;
  }
  .nav-right {
    position: absolute;
    left: calc(100% - 22px);
    top: 50%;
    z-index: 10;
  }
  .standard-dialog-fullscreen-content {
    position: relative;
    height: calc(100% - 48px);
    width: 100%;
    justify-content: center;
    align-items: center;
    overflow: hidden;
  }
  .dialog_slide-enter, .dialog_slide-leave-to {
  transform: translateY(100vh);
  }
  .dialog_slide-enter-active, .dialog_slide-leave-active {
    transition: transform 0.2s ease-in-out;
  }
</style>
